<template>
  <b-card class="text-center">
    <template #header>
      <template v-if="me">Teams I belong to</template>
      <template v-else>Belongs to</template>
    </template>
    <div class="ml-4 mr-4 mb-2">
      <div v-for="team in teams" :key="team.id" class="mt-3 mb-3">
        <b-link :to="{ name: 'Team', params: { teamId: team.id } }">
          <avatar
            :src="team.photo"
            variant="team"
            size="3.125rem"
          />
          <div>{{team.name}}</div>
        </b-link>
      </div>
    </div>
  </b-card>
</template>

<script>
import Avatar from '@/components/common/Avatar'

export default {
  name: 'BelongsToTeams',

  props: {
    me: {
      type: Boolean,
      default: false
    },

    teams: {
      type: Array,
      default: () => ([])
    }
  },

  components: {
    Avatar
  }
}
</script>
